import { matchPath, useLocation } from 'react-router-dom';
import { IBordPageBreadcrumbItem } from 'components/BordPageHeader/BordPageHeader';

interface IBreadcrumbRouteConfig {
  items: (params: Record<string, string>) => IBordPageBreadcrumbItem[];
}

/**
 * Configura los breadcrumbs para cada ruta que usa BordPageHeader.
 * Añadir aquí una nueva entrada para habilitar el nuevo header en una ruta adicional.
 */
const BREADCRUMB_ROUTES: Record<string, IBreadcrumbRouteConfig> = {
  '/quote/edit/:id': {
    items: ({ id }) => [
      { label: 'Cotizaciones', href: '/quote/list' },
      { label: 'Detalle de la cotización', href: `/quote/details/${id}` },
      { label: 'Editar cotización' }
    ]
  }
};

/**
 * Detecta si la ruta activa está configurada para usar BordPageHeader y devuelve
 * los ítems del breadcrumb correspondientes, interpolando los params de la URL.
 * Devuelve null si la ruta no está en la configuración.
 */
const usePageBreadcrumb = (): IBordPageBreadcrumbItem[] | null => {
  const { pathname } = useLocation();

  for (const pattern of Object.keys(BREADCRUMB_ROUTES)) {
    const match = matchPath<Record<string, string>>(pathname, { path: pattern, exact: true });
    if (match) return BREADCRUMB_ROUTES[pattern].items(match.params);
  }

  return null;
};

export default usePageBreadcrumb;
